/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Auth_Callback_RedirectingInputs */

const en_common_auth_callback_redirecting = /** @type {(inputs: Common_Auth_Callback_RedirectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signing you in…`)
};

const zh_common_auth_callback_redirecting = /** @type {(inputs: Common_Auth_Callback_RedirectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在跳转…`)
};

/**
* | output |
* | --- |
* | "Signing you in…" |
*
* @param {Common_Auth_Callback_RedirectingInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_auth_callback_redirecting = /** @type {((inputs?: Common_Auth_Callback_RedirectingInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Auth_Callback_RedirectingInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_auth_callback_redirecting(inputs)
	return zh_common_auth_callback_redirecting(inputs)
});
export { common_auth_callback_redirecting as "common.auth_callback.redirecting" }